import _nativeCreate_default from "./_nativeCreate.js";

//#region ../../node_modules/lodash-es/_hashClear.js
/**
* Removes all key-value entries from the hash.
*
* @private
* @name clear
* @memberOf Hash
*/
function hashClear() {
	this.__data__ = _nativeCreate_default ? _nativeCreate_default(null) : {};
	this.size = 0;
}
var _hashClear_default = hashClear;

//#endregion
export { _hashClear_default as default };
//# sourceMappingURL=_hashClear.js.map